import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiHelper } from 'cad/common/services/api/api-helper';

@Injectable()
export class Contact {

  private readonly endpoint: string = 'associate/address/';
  private suffix: string = '/contact';

  constructor(
    private apiHelper: ApiHelper,
  ) {}

  public findAll = (addressId: string | number): Observable<any> => {
    return this.apiHelper.request(this.endpoint + addressId + this.suffix);
  }

  public save = (contactAddresses: any[]): Observable<any> => {
    return this.apiHelper.request(this.endpoint + contactAddresses[0].addressId + this.suffix, { body: contactAddresses });
  }
}
